<template>
  <div :id="appName" :class="[appCode, appName]" class="sm social-management">
    <router-view :name="appCode"></router-view>
    <sm-portal-target name="sm-dialog-destination" class="dialog-portal" :multiple="true"></sm-portal-target>

  </div>
</template>

<script>
import { appCode, appName } from '@/common/consts';

export default {
  name: appCode,
  data() {
    return {
      appName,
      appCode,
    };
  },
  created() {
    document.title = this.$t(`${this.$route.name}.appTitle`);
  },
};
</script>

<style lang="scss" scoped>

  .social-management {
    height: 100%;
    padding: 4rem;
    text-align: center;
    overflow: scroll;
    @include themify {
      background-color: getColor('background');
      color: getColor('text');
    }
    background-color: #f2f2f2;
    /* some variables (and mixins) are available anywhere without the need of imports, */
    /* look for 'sass-resources-loader' in this project to see what else is included. */
    font-family: $font-family-Roboto;

    h1 {
      margin: 1rem 0;
      font-size: 2rem;
    }

    nav {
      margin: 1rem 0;

      a {
        margin: 0 .75em;
        border-bottom: 1px solid;
        text-decoration: none;
        font-size: 1.25rem;
        color: #2575f2;
        opacity: .7;

        &.router-link-exact-active {
          opacity: 1;
        }
      }
    }
    .dialog-portal {
      .le-dialog {
        text-align: justify;
        .dialog-box {
          .inner-dialog {
            .footer {
              .cancel {
                float: initial;
                margin-right: 16px;
              }
            }
          }
        }
      }
    }
  }

</style>
